import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../store/types";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../routes";
import Company from "../Company";
import DeveloperHome from "./DeveloperHome";
import CustomerHome from "./CustomerHome";
import CompanyHome from "./CompanyHome";

const Home = () => {
    const { loggedInUser } = useSelector((state: RootState) => state.global);
    const navigate = useNavigate();

    return (<>
        {loggedInUser?.userType === "Customer" && <CustomerHome />}
        {loggedInUser?.userType === "Company" && <CompanyHome />}
        {loggedInUser?.userType === "Developer" && <DeveloperHome />}
    </>
    );
};

export default Home;
